import React, {Component} from 'react';
import {View} from 'react-native';
import Requests from '../api/Requests';
import {TableContainer} from '../components/table/Table';
import styled, {css} from 'styled-components/native';
import {colours, spacing} from '../styles/Style';
import {
  GetGlobalTheme,
  DataTypes,
  WindowTypes,
  IsHRWeb,
  GetParameterID,
  GetDefaultBackBehaviour,
  WindowWrap,
  IsHRiOS,
  goBack,
  DoNavigate,
  IsManager,
  ScreenHeight,
  ScreenWidth,
  DisplayBrowseOKFlag,
  UsePagination,
  ResetRecord,
} from '../Tools/DisplayTools';
import {ActionButton} from '../components/button/ActionButton';
import {InspectWindow} from '../components/edit_elements/InspectWindow';
import EditField from '../components/edit_elements/EditField';
import {translate} from '../Tools/LanguageTools';
import {SetCurrentWindow2, AddDateFilter} from '../Tools/WindowTools';
import {Modal} from 'react-native';
import {YesNoWindow} from '../components/status/YesNoWindow';
import {createDrawerNavigator} from '@react-navigation/drawer';
import {FixRecordMissingFields} from '../Tools/RecordTools';

const kDefPerPage = 20;
const Drawer = createDrawerNavigator();

let FilterView;
if (IsHRWeb()) {
  FilterView = styled.View`
    position: absolute;
    top: 100%;
    right: 0px;
    width: 340px;
    background: ${colours[GetGlobalTheme()].lightBackground};
    padding: 20px;
    flex-direction: column;
    align-items: center;
  `;
} else {
  if (IsHRiOS()) {
    FilterView = styled.View`
      position: absolute;
      height: ${ScreenHeight()};
      width: ${ScreenWidth()};
      background: ${colours[GetGlobalTheme()].lightBackground};
      padding: 6px;
    `;
  } else {
    FilterView = styled.Modal``;
  }
}

const VacationInfo = styled.View`
  padding: ${spacing.small300}px;
`;
const VacationInfoText = styled.Text`
  margin-bottom: 10px;
`;

const FilterViewInner = styled.View`
  ${IsHRWeb() == false &&
  css`
    height: 100%;
    width: 100%;
    background-color: ${colours[GetGlobalTheme()].siteBackground};
  `};
  ${IsHRiOS() &&
  css`
    padding-top: 50;
  `};
`;

const FilterFields = styled.View`
  ${IsHRWeb() &&
  css`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    /*margin-right: -30px;*/
    width: 100%;
  `}
`;
const FilterField = styled.View`
  ${IsHRWeb() &&
  css`
    /*margin-right: 30px;*/
  `}
`;
const FilterActions = styled.View`
  display: flex;
  ${(IsHRWeb() &&
    css`
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: flex-end;
    `) ||
  css`
    flex-direction: column-reverse;
  `}
`;

function RecordColumns(table) {
  let res = [
    {
      group: {
        fields: [
          {
            title: translate('SerNr'),
            dataKey: 'SerNr',
            viewOnly: true,
            width: '100px',
          },
          {
            title: translate('Contract'),
            dataKey: 'ContractNr',
            viewOnly: false,
            width: '400px',
            pasteSpecial: 1,
            pasteSpecialMulti: false,
            pasteSpecialHeader: [
              {
                name: translate('Code'),
                width: '35%',
                key: 'contractnr',
                mainkey: 'ContractNr',
              },
              {
                width: '65%',
                name: translate('Name'),
                key: 'empname',
              },
            ],
            onChange: table.updateRecordField,
          },
          {
            title: translate('Approved'),
            title2: translate('Approve'),
            dataKey: 'Status',
            viewOnly: false,
            type: DataTypes.kInputTypeCheckbox,
            onChange: table.updateRecordField,
          },
        ],
      },
    },
    {
      group: {
        fields: [
          {
            title: translate('Date'),
            dataKey: 'TransDate',
            viewOnly: false,
            width: '150px',
            type: DataTypes.kInputTypeDate,
            onChange: table.updateRecordField,
          },
          {
            title: translate('StartDate'),
            dataKey: 'StartDate',
            viewOnly: false,
            width: '150px',
            type: DataTypes.kInputTypeDate,
            onChange: table.updateRecordField,
          },
          {
            title: translate('EndDate'),
            dataKey: 'EndDate',
            viewOnly: false,
            width: '150px',
            linkedfield: 'StartDate',
            type: DataTypes.kInputTypeDate,
            onChange: table.updateRecordField,
          },
        ],
      },
    },
    {
      group: {
        fields: [
          {
            title: translate('Department'),
            dataKey: 'DepCode',
            viewOnly: false,
            width: '300px',
            pasteSpecial: 7,
            pasteSpecialHeader: [
              {
                name: translate('Code'),
                width: '35%',
                key: 'DepCode',
                mainkey: 'DepCode',
              },
              {
                width: '65%',
                name: translate('Name'),
                key: 'Name',
              },
            ],
            onChange: table.updateRecordField,
          },
        ],
      },
    },
    {
      group: {
        fields: [
          {
            title: translate('Comment'),
            dataKey: 'Comment',
            viewOnly: false,
            width: '500px',
            onChange: table.updateRecordField,
          },
        ],
      },
    },
  ];
  return res;
}

function BrowseColumns(window) {
  let res = [
    {
      title: translate('SerNr'),
      dataKey: 'sernr',
      sortKey: 'SerNr',
      width: '100px',
    },
    {
      title: translate('ContractNr'),
      dataKey: 'contractnr',
      sortKey: 'ContractNr',
      width: '100px',
    },
    {
      title: translate('Name'),
      dataKey: 'empname',
      sortKey: 'EmpName',
      width: '200px',
    },
    {
      title: translate('StartDate'),
      dataKey: 'startdate',
      sortKey: 'StartDate',
      width: '115px',
      type: DataTypes.kInputTypeDate,
    },
    {
      title: translate('EndDate'),
      dataKey: 'enddate',
      sortKey: 'EndDate',
      width: '115px',
      type: DataTypes.kInputTypeDate,
    },
    {
      title: translate('Department'),
      dataKey: 'depcode',
      sortKey: 'DepCode',
      width: '100px',
    },
    {
      title: translate('ApprovedShort'),
      dataKey: 'status',
      sortKey: 'Status',
      width: '70px',
      overwrite: DisplayBrowseOKFlag,
    },
  ];
  return res;
}

class ContractChangesList extends Component {
  constructor(props) {
    super(props);
    let self = this;
    this.createNewContractChange = this.createNewContractChange.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.renderNewButton = this.renderNewButton.bind(this);
    //this.changePage = this.changePage.bind(this);
    this._isMounted = true;
    this.table = 38;
    this.ScreenName = 'ContractChanges';
    this.init = true;
    this.state = {
      data: [],
      record: {},
      show: false,
      newContractChangeHelper: false,
      NewEmp: '',
      NewGroup: '',
      px: 0,
      py: 0,
      NewStartDate: '',
      NewEndDate: '',
      NewEmpVacDays: [],
      update: false,
    };
    this.navigation = props.navigation;
    SetCurrentWindow2('ContractChanges', 'SerNr', 'descending');
    AddDateFilter('ContractChanges');
  }
  getBrowseListData = () => {
    let self = this;
    Requests.getTableData(this.table, undefined, undefined, undefined, true)
      .then((response) => {
        if (self._isMounted) {
          self.setState({data: response.records});
        }
      })
      .catch((error) => {});
  };
  displayBrowseList = () => {
    this.state.WindowType = WindowTypes.Browse;
    this.getBrowseListData();
  };
  rowClick = (id) => {
    DoNavigate(this, 'ContractChanges', true, id);
  };
  CheckNewChangeData = () => {
    let res = true;
    if (this.state.NewEmp == '') {
      res = false;
    }
    if (this.state.NewStartDate == '') {
      res = false;
    }
    return res;
  };

  createNewContractChange = () => {
    let self = this;
    let tdata;
    if (this.CheckNewChangeData() == false) {
      global.messageBox({
        showMessage: true,
        statusMessage: translate('FillMandFields'),
      });
      return;
    }
    if (global.userData.provider == 0) {
      tdata = {
        record: {
          ContractNr: this.state.NewEmp,
          StartDate: this.state.NewStartDate,
          EndDate: this.state.NewEndDate,
        },
      };
    }
    Requests.getNewRecord(this.table, tdata)
      .then((response) => {
        if (response.hasOwnProperty('record')) {
          self.state.NewEmp = '';
          self.state.NewStartDate = '';
          self.state.NewEndDate = '';
          self.ShowHideNewContractChange();
          if (UsePagination() == false) {
            self.getBrowseListData();
          }
          self.rowClick(response.record.SerNr);
        }
      })
      .catch((error) => {});
  };

  componentDidMount() {
    let self = this;
    this.focusSubscription = this.props.navigation.addListener('focus', () => {
      SetCurrentWindow2('ContractChanges', 'SerNr', 'descending');
      if (UsePagination() == false) {
        self.getBrowseListData();
      } else {
        if (self.init == false) {
          self.setState({update: self.state.update ? false : true});
        }
        self.init = false;
      }
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  ShowHideNewContractChange = () => {
    if (this.state.newContractChangeHelper) {
      global.PopEscapeActions();
      this.setState({newContractChangeHelper: false});
    } else {
      this.setState({newContractChangeHelper: true});
      global.PushEscapeActions(() => this.ShowHideNewContractChange());
    }
  };
  renderNewButton = () => {
    let self = this;
    let style = {};
    if (IsHRWeb()) {
      style = {marginRight: '20px'};
    }
    let style2 = {};
    if (IsHRiOS()) {
      style2 = {
        left: -this.state.px,
        top: -this.state.py,
      };
    }
    return (
      <View
        key={'contractchange_new'}
        style={{flexDirection: 'row'}}
        onLayout={(event) => {
          const layout = event.nativeEvent.layout;
          self.setState({py: layout.y, px: layout.x});
        }}
      >
        <ActionButton
          onPress={() => this.ShowHideNewContractChange()}
          title={translate('AddNew')}
        />
        {this.state.newContractChangeHelper && (
          <FilterView style={style2}>
            <FilterViewInner>
              <FilterFields>
                <FilterField>
                  <EditField
                    title={translate('StartDate') + '*'}
                    name={'StartDate'}
                    value={this.state.NewStartDate}
                    editable={true}
                    width={'150px'}
                    type={DataTypes.kInputTypeDate}
                    onChange={(index, fn, value) =>
                      self.setState({NewStartDate: value})
                    }
                  />
                </FilterField>
                <FilterField>
                  <EditField
                    title={translate('EndDate') + '*'}
                    name={'EndDate'}
                    value={this.state.NewEndDate}
                    editable={true}
                    width={'150px'}
                    record={{StartDate: this.state.NewStartDate}}
                    linkedfield={'StartDate'}
                    type={DataTypes.kInputTypeDate}
                    onChange={(index, fn, value) =>
                      self.setState({NewEndDate: value})
                    }
                  />
                </FilterField>
                <FilterField style={{width: '100%'}}>
                  <EditField
                    title={translate('Contract') + '*'}
                    name={'EmpCode'}
                    value={this.state.NewEmp}
                    ps={1}
                    editable={IsManager()}
                    psheader={[
                      {
                        name: translate('ContractNr'),
                        width: '35%',
                        key: 'contractnr',
                        mainkey: 'ContractNr',
                      },
                      {
                        width: '65%',
                        name: translate('Name'),
                        key: 'empname',
                      },
                    ]}
                    onChange={(index, fn, value) =>
                      self.setState({NewEmp: value})
                    }
                  />
                </FilterField>
              </FilterFields>
              <FilterActions>
                <ActionButton
                  style={style}
                  onPress={() => this.ShowHideNewContractChange()}
                  title={translate('Cancel')}
                />
                <ActionButton
                  onPress={() => this.createNewContractChange()}
                  title={translate('Create')}
                />
              </FilterActions>
              {this.state.NewEmpVacDays}
            </FilterViewInner>
          </FilterView>
        )}
      </View>
    );
  };
  render() {
    let self = this;
    return (
      <WindowWrap>
        <TableContainer
          table={this.table}
          update={this.state.update}
          data={this.state.data}
          columns={BrowseColumns(this)}
          doClick={self.rowClick}
          rowID={'sernr'}
          title={translate(this.ScreenName)}
          width="900px"
          extraContent={this.renderNewButton}
        />
      </WindowWrap>
    );
  }
}

class ContractChangesRecord extends Component {
  constructor(props) {
    super(props);
    let self = this;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateRecordField = this.updateRecordField.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this._isMounted = true;
    this.table = 38;
    this.ScreenName = 'ContractChanges';
    this.state = {
      data: [],
      record: {},
      show: false,
      message: [],
      WindowType: WindowTypes.Browse,
      hasapprovals: -1,
      NewEmpVacDays: [],
      ApprovalStatus: '',
      ApprovalStatusText: '',
    };
    this.navigation = props.navigation;
    if (props.route.params?.id) {
      this.state.ActiveID = props.route.params.id;
      this.rowClick(props.route.params.id);
    }
  }
  rowClick = (id) => {
    let self = this;
    this.state.WindowType = WindowTypes.Inspect;
    this.state.hasapprovals = -1;
    this.setState({record: {}});
    Requests.getTableData(this.table, {SerNr: id}, undefined, undefined, true)
      .then((response) => {
        self.setState({
          id: response.records[0]['SerNr'],
          record: response.records[0],
        });
      })
      .catch((error) => {});
  };
  updateRecordField = (rowindex, index, value) => {
    let self = this;
    /*
    if (rowindex > -1) {
      this.state.record.rows[rowindex][index] = value;
    } else {
      this.state.record[index] = value;
    }
*/
    Requests.updateRecordData(this.table, {
      field: index,
      rownr: rowindex,
      value: value,
      id: this.state.record.SerNr,
    })
      .then((response) => {
        if (response.success) {
          if (self._isMounted) {
            self.state.record = {};
            let record = FixRecordMissingFields(
              response.record,
              RecordColumns(this)
            );
            self.setState({record: record});
          }
        } else {
          if (self._isMounted) {
            ResetRecord(self, index, rowindex, value);
          }
        }
      })
      .catch((error) => {});
  };
  handleInputChange = (rowindex, index, event) => {
    this.updateRecordField(rowindex, index, event.target.value);
  };

  componentDidMount() {}
  componentDidUpdate() {
    let param_id = GetParameterID(this);
    if (this.state.ActiveID != param_id && param_id != '') {
      this.state.ActiveID = param_id;
      this.rowClick(this.state.ActiveID);
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  deleteRecord = () => {
    let self = this;
    this.setState({activeDelete: false});
    Requests.deleteRecord(this.table, this.state.record.SerNr)
      .then((response) => {
        self.state.ActiveID = '';
        DoNavigate(self, 'ContractChanges', false, '', true, true);
      })
      .catch((error) => {});
  };

  render() {
    let self = this;
    return (
      <WindowWrap>
        <InspectWindow
          title={translate('ContractChange')}
          window={this}
          headerfields={RecordColumns(this)}
          record={this.state.record}
          onClick={this.handleInputClick}
          allowDelete={true}
          okcheck={'Status'}
          backButton={() => goBack(self, self.ScreenName)}
        />
        {this.state.activeDelete && (
          <Modal transparent={true}>
            <YesNoWindow
              question={translate('RemoveQuestion')}
              yes={() => this.deleteRecord()}
              no={() => this.setState({activeDelete: false})}
            />
          </Modal>
        )}
      </WindowWrap>
    );
  }
}

function ContractChanges() {
  return (
    <Drawer.Navigator
      style={{background: 'white'}}
      screenOptions={{headerShown: false}}
      backBehavior={GetDefaultBackBehaviour()}
      drawerStyle={{display: 'none'}}
    >
      <Drawer.Screen
        name="ContractChangesList"
        component={ContractChangesList}
        options={{
          title: translate('ContractChanges'),
        }}
      />
      <Drawer.Screen
        name="ContractChangesRecord"
        component={ContractChangesRecord}
        backBehavior={GetDefaultBackBehaviour()}
        options={{
          title: translate('ContractChange'),
        }}
        getId={({params}) => params.id}
      />
    </Drawer.Navigator>
  );
}

export default ContractChanges;
